import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=29225a7a"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports